import React from 'react'

const ContentArea: React.FC = ({ children }) => {
  return <div className="mb-10 mt-8 space-y-10 md:mt-10">{children}</div>
}

export { ContentArea }
